import React, { useContext, useState } from "react";
import { useForm } from "react-hook-form";
import "./TicketForm.css";
import { AppContext } from "../../../Context/Context";
import CommonBreadCrumb from "../../../Commonalert/commonbreadcrumb";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from "axios";
import CommonErrorAlert from "../../../Commonalert/commonalert";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import {Container, Box} from '@mui/material';
import Grid from '@mui/material/Grid';

const CreateTicketForm = () => {
  const { isMenuExpanded } = useContext(AppContext);
  const navigate = useNavigate();
  const esodata = useSelector((state) => state);
  const ApiToken = esodata.apiauthkey.value;

  const [cardmsg, setCardmsg] = useState([]);
  const [open, setOpen] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const handleClose = () => {
    setOpen(false);
    navigate("/support-open-ticket-list");
  };

  const onSubmit = async (data) => {
    setSubmitting(true);

    try {
      const formData = new FormData();
      formData.append("title", data.title);
      formData.append("description", data.description);

      // ✅ Append multiple files
      if (data.document && data.document.length > 0) {
        Array.from(data.document).forEach((file) => {
          formData.append("attachment", file); // or use "attachments" based on backend
        });
      }
console.log("FormData entries:");
for (let [key, value] of formData.entries()) {
  console.log(`${key}:`, value);
}
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}support_tickets/create_ticket/`,
        formData,
        {
          headers: {
            Authorization: `${ApiToken}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.status === 200 || response.status === 201) {
        setOpen(true);
        setCardmsg(response?.data?.message);
      } else {
        setOpen(true);
        setCardmsg(response?.data?.message);
        console.error("Backend error:", response.data);
      }
    } catch (error) {
      console.error("Submission error:", error);
      setCardmsg("Something went wrong. Please try again later.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      className={`over_all_container search_prnt ${
        isMenuExpanded ? "blur overflow-hidden" : ""
      }`}
    >

 <Helmet>
          <meta charSet="utf-8" />
          <title>Create Ticket</title>
        </Helmet>

<Container maxWidth={false} className="dashboard-container">
        <Box className="dashboard-box">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={4}>
              <div>
                <h1 className="dashboard_header">
                  Create Ticket
                </h1>
              </div>
            </Grid>
            <Grid item xs={12} md={8}>
              <div className="top_breadcrumb_menu">
                <div className="exportpdf_outer">
                  <div className="breadcrumb-wrapper">
                    <CommonBreadCrumb breadcrumbValue={[
                      { title: 'Create Ticket', active: true }
                    ]} />
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>



      {/* <CommonBreadCrumb
        breadcrumbValue={[{ title: "Support Ticket", activeColor: true }]}
      /> */}

      {/* <div className="cnt_hdr_top_wraps">
        <div className="cnt_hdr_top_lft_wrap">
          <h2 className="heading_font">Support Ticket</h2>
        </div>
       
      </div> */}

      <form
        className="ticket-form"
        onSubmit={handleSubmit(onSubmit)}
        encType="multipart/form-data"
      >
      
        <div className="form-group dialog-input-form" style={{marginBottom:"20px"}}>
          <label className="reportName">
            Title <span style={{ color: "red" }}>*</span>
          </label>
          <input
          className="dialog-input-text"
            type="text"
            placeholder="Write your issues"
            {...register("title", { required: "Title is required" })}
          />
          {errors.title && (
            <span className="error">{errors.title.message}</span>
          )}
        </div>

       
        <div className="form-group">
          <label className="reportName">
            Issue Description <span style={{ color: "red" }}>*</span>
          </label>
          <textarea
            placeholder="Write your description"
            {...register("description", {
              required: "Description is required",
            })}
          />
          {errors.description && (
            <span className="error">{errors.description.message}</span>
          )}
        </div>

       
        <div className="form-group">
          <label className="reportName">Upload Document(s)</label>
          <input style={{border:"0", padding:"3px", marginBottom:"10px"}}
            type="file"
            {...register("document")}
            multiple 
          />
          <span style={{ fontSize: "12px" }}>
            Note: Attach any images/videos/files that may assist us to help you
          </span>
        </div>

      
        <div className="dialog-action-button" style={{justifyContent:"center"}}>
          <button type="submit" className="form_submit_btn" disabled={submitting}>
            {submitting ? "Submitting..." : "Create Ticket"}
          </button>

          <button
            type="button"
            className="form_submit_btn"
            onClick={() => navigate("/support-open-ticket-list")}
            disabled={submitting}
          >
            Cancel
          </button>
        </div>
      </form>

       {/* <form
        className="ticket-form"
        onSubmit={handleSubmit(onSubmit)}
        encType="multipart/form-data"
      >
      
        <div className="form-group">
          <label className="reportName">
            Title <span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="text"
            placeholder="Write your issues"
            {...register("title", { required: "Title is required" })}
          />
          {errors.title && (
            <span className="error">{errors.title.message}</span>
          )}
        </div>

       
        <div className="form-group">
          <label className="reportName">
            Issue Description <span style={{ color: "red" }}>*</span>
          </label>
          <textarea
            placeholder="Write your description"
            {...register("description", {
              required: "Description is required",
            })}
          />
          {errors.description && (
            <span className="error">{errors.description.message}</span>
          )}
        </div>

       
        <div className="form-group">
          <label className="reportName">Upload Document(s)</label>
          <input
            type="file"
            {...register("document")}
            multiple 
          />
          <span style={{ fontSize: "12px" }}>
            Note: Attach any images/videos/files that may assist us to help you
          </span>
        </div>

      
        <div className="form-actions">
          <button type="submit" className="submit" disabled={submitting}>
            {submitting ? "Submitting..." : "Create Ticket"}
          </button>

          <button
            type="button"
            className="cancel"
            onClick={() => navigate("/support-open-ticket-list")}
            disabled={submitting}
          >
            Cancel
          </button>
        </div>
      </form> */}

      <Container maxWidth={false} className="footer-container">
              <Box className="footer-box">
                <Grid container className="footer-grid">
                  <Grid item xs={12} md={6}>
                    <div className="footer-left">
                      <p className="footer-text">
                        All Rights Reserved Copyright © 2026 |
                        <a href="https://www.egrovesys.com/" target="blank">
                          <span className="footer-brand"> Elite site Optimizer</span>
                        </a>
                      </p>
                    </div>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <div className="footer-right">
                    
                    </div>
                  </Grid>
                </Grid>
              </Box>
            </Container>

      {/* Alert Dialog */}
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle className="keyword-dialog-header">Alert</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {cardmsg}
          </DialogContentText>
        </DialogContent>
        <DialogActions className="dialog-action-button">
          <Button onClick={handleClose}>Close</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default CreateTicketForm;
